/**
 * RestrictedVisibilityPrompt - Prompts user to start restricted visibility checklist
 * Triggered when weather is logged with fog/mist/restricted visibility conditions
 */
import React from 'react';
import { AlertTriangle, CheckSquare, X, Clock } from 'lucide-react';

const RestrictedVisibilityPrompt = ({ isOpen, onConfirm, onDismiss, onLater, visibility }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50" />

      {/* Dialog */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-md">
          {/* Header */}
          <div className="flex items-center gap-3 px-6 py-4 bg-amber-500 rounded-t-2xl">
            <AlertTriangle className="h-6 w-6 text-white" />
            <h2 className="text-lg font-semibold text-white">Restricted Visibility Detected</h2>
          </div>

          {/* Content */}
          <div className="px-6 py-5">
            <p className="text-gray-700 mb-4">
              You've logged visibility as <strong>"{visibility}"</strong>.
              COLREGs Rule 19 requires specific procedures in restricted visibility conditions.
            </p>
            <p className="text-gray-600 text-sm">
              Would you like to start the Restricted Visibility Checklist?
            </p>
          </div>

          {/* Actions */}
          <div className="px-6 py-4 bg-gray-50 rounded-b-2xl flex flex-col sm:flex-row gap-2">
            <button
              onClick={onConfirm}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-white bg-cyan-600 rounded-lg hover:bg-cyan-700 transition-colors"
            >
              <CheckSquare className="h-4 w-4" />
              Start Checklist
            </button>
            <button
              onClick={onLater}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <Clock className="h-4 w-4" />
              Remind Later
            </button>
            <button
              onClick={onDismiss}
              className="flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors"
            >
              <X className="h-4 w-4" />
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestrictedVisibilityPrompt;
